import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

export function initLightbox() {
  GLightbox({
    selector: '.gallery-lightbox',
    touchNavigation: true,
    loop: true,
    autoplayVideos: false,
    closeOnOutsideClick: true,
  });
}